const cloudinaryConfig = {
  cloudName: process.env.CLOUDINARY_NAME,
  apiKey: process.env.CLOUDINARY_API_KEY,
  apiSecret: process.env.CLOUDINARY_API_SECRET,
  uploadPreset: process.env.CLOUDINARY_UPLOAD_PRESET,
};

const isRawFile = (file) => {
  const name = (file.name && file.name.toLowerCase()) || '';
  const type = file.type || '';
  return (
    type === 'application/msword' || 
    type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || // .docx
    name.endsWith('.doc') ||
    name.endsWith('.docx')
  );
};

// `uploadPreset` defaults to `type`; pass an existing preset to reuse it for a new folder
const uploadToCloudinary = async (file, type, uploadPreset = type) => {
  const folder = `pertime/user/${type}`;

  const resourceType = isRawFile(file) ? 'raw' : 'image';

  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', uploadPreset);
    formData.append('folder', folder);

    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${cloudinaryConfig.cloudName}/${resourceType}/upload`,
      {
        method: 'POST',
        body: formData,
      }
    );
    if (!response.ok) {
      throw new Error(`Upload failed with status ${response.status}`);
    }
    const data = await response.json();
    return data.secure_url;
  } catch (error) {
    console.error(`Error uploading to Cloudinary (${folder}):`, error);
    throw new Error('Failed to upload file to Cloudinary');
  }
};
export { uploadToCloudinary };


// WEBPACK FOOTER //
// ./src/utils/cloudinary.js